import "./productListingRelated.scss";

import ProductListingSingle from "./ProductListingSingle";
import React from "react";
import classNames from "classnames";
import useMobileDetect from "../../hooks/useMobileDetect";

type ProductListingRelatedProps = {
  columns: string;
  products: any[];
  scroll: any;
};

export default function ProductListingRelated(props: ProductListingRelatedProps) {
  const { columns, products, scroll } = props;

  const isMobile = useMobileDetect().isMobile();

  const maxTile = isMobile ? 2 : 3;

  const showArrow = scroll.length <= maxTile ? false : true;

  return (
    <div className={`productListingRelated col-${columns}`}>
      <div className="container">
        {products.map((product: any) => (
          <ProductListingSingle product={product} key={product.code} />
        ))}

        <div
          className={classNames("option-prev option-nav", {
            "d-none": !showArrow,
          })}
        >
          <span
            className={scroll.relatedIndex !== 0 ? "iconfont iconfont-prev" : "iconfont iconfont-prev not-clickable"}
            onClick={() => scroll.relatedIndex !== 0 && scroll.setRelatedIndex(scroll.relatedIndex - 1)}
          />
        </div>
        <div
          className={classNames("option-next option-nav", {
            "d-none": !showArrow,
          })}
        >
          <span
            className={
              scroll.relatedIndex < scroll.length - maxTile
                ? "iconfont iconfont-next"
                : "iconfont iconfont-next not-clickable"
            }
            onClick={() =>
              scroll.relatedIndex < scroll.length - maxTile && scroll.setRelatedIndex(scroll.relatedIndex + 1)
            }
          />
        </div>
      </div>
    </div>
  );
}
